import { http } from '@/common/utils/HttpServices';
import { Routes } from '@/api/Routes';

class NoteReclamationService {
    public async noterReclamation(reclamationId: number, note: number): Promise<any> {
        return http.get(Routes.ReclamationRoutes.SendNoteReclamation(reclamationId, note));
    }
}

export default new NoteReclamationService();
